import { routeAccess } from 'constants/permission';
import { useHasPermission } from 'hooks/usePermission';
import { Redirect, Route } from 'react-router-dom';

interface PrivateRouteProps {
  path: string;
  component: any;
  [property: string]: any;
}
const PrivateRoute = ({ path, component: Component, ...reset }: PrivateRouteProps) => {
  let hasPermision = useHasPermission(routeAccess[path]);
  if (['/', '/403'].includes(path)) {
    hasPermision = true;
  }
  return <Route path={path} {...reset} render={(props) =>
    hasPermision ? (
      <Component {...props} />
    ) : (
      <Redirect to="/403" />
    )
  } ></Route>;
};

export default PrivateRoute;